const images = {
    logo: "/logo.png",
    panda: "/panda.jpg",
    loading: "/loading.gif",
}

export default images;